import script from "./PhotoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoDetail.vue?vue&type=script&setup=true&lang=js"

import "./PhotoDetail.vue?vue&type=style&index=0&id=3ca2de02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca2de02"]])

export default __exports__